<template>
  <div class="orderPage">
    <div v-if="step == 1">
      <div class="title line">销售代客下单（销售业务订单）</div>
      <div class="shop_intro_wrap line">
        <div class="shop_list" v-if="selectIndexArr.length > 0">
          <div
            class="shop_item"
            v-for="(item, index) in selectIndexArr"
            :key="index"
          >
            <h1>商品名称：{{ item.commodityname }}</h1>
            <div class="txt">
              <p
                v-for="(itemAttr, indexAttr) in item.attrItem"
                :key="indexAttr"
              >
                {{ itemAttr }}
              </p>
            </div>
            <h1>
              商品数量：<span>{{ item.num }}</span>
            </h1>
            <h1>
              商品单价：￥<span>{{ item.price | formatPrice }}</span>
            </h1>
            <h1>
              商品总价：￥<span>{{ item.price_total | formatPrice }}</span>
            </h1>
            <div class="set_wrap flex-between">
              <p @click="handleSetShopAttr(item, index)">
                商品属性参数设置 <i class="iconfont icon-gengduo"></i>
              </p>
              <p @click="handleRemoveShop(index)">
                移除此商品 <i class="iconfont icon-guanbi"></i>
              </p>
            </div>
          </div>
        </div>
        <van-empty description="暂无商品" v-else />
        <div class="add_btn flex-rowc" @click="handleAddShop">
          <i class="iconfont icon-components"></i> 添加商品
        </div>
      </div>
      <!-- 收货信息 -->
      <div class="receive_goods_info_wrap line">
        <div class="form_wrap">
          <div class="info_wrap">
            <div class="info_item flex-rowl">
              <p class="label">客户名称：</p>
              <p>
                {{
                  customerDetail.info_truename
                    ? customerDetail.info_truename
                    : customerDetail.ext_name
                }}
              </p>
            </div>
            <div class="info_item flex-rowl">
              <p class="label">企业名称：</p>
              <p>{{ customerDetail.other_companystr }}</p>
            </div>
            <div class="info_item flex-rowl">
              <p class="label">联系方式：</p>
              <p>{{ customerDetail.info_mobile }}</p>
            </div>
            <div class="info_item flex-rowl">
              <p class="label">所在地区：</p>
              <p>
                <span v-if="customerDetail.other_provincename">{{
                  customerDetail.other_provincename
                }}</span>
                <span v-if="customerDetail.other_cityname"
                  >、{{ customerDetail.other_cityname }}</span
                >
                <span v-if="customerDetail.other_areaname"
                  >、{{ customerDetail.other_areaname }}</span
                >
                <span v-if="customerDetail.other_address"
                  >、{{ customerDetail.other_address }}</span
                >
              </p>
            </div>
            <div class="info_item address_item">
              <div class="txt">物流配送信息：</div>
              <div class="address_box" v-if="formData.addr">
                <p>收件人：{{ formData.truename }}</p>
                <p>收件人联系方式：{{ formData.cellphone }}</p>
                <p>收件人地址：{{ formData.addr }}</p>
              </div>

              <div class="add_btn flex-rowc" @click="handleShowAddress">
                + 选择物流配送信息
              </div>
            </div>
            <!-- <div class="info_item address">
              <div class="txt flex-rowl">
                <p>{{
                customerDetail.other_provincename
              }}</p>
                <p>测试区域</p>
              </div>
              <p>
                详细地址信息，预设输入时最多输入50个中文字，在这里显示时
                可以换行，最多三行
              </p>
            </div> -->
          </div>
          <!-- <div class="list">
            <div class="tit">
              <i class="iconfont icon-address-outlined"></i> 选择配送地址
            </div>
            <div class="item flex-between" @click="handleShow(1)">
              <van-field
                readonly
                v-model="provinceTxt"
                placeholder="选择省/直辖市"
              />
              <van-icon name="arrow" class="arrow" />
            </div>
            <div class="item flex-between" @click="handleShow(2)">
              <van-field readonly v-model="cityTxt" placeholder="选择城市" />
              <van-icon name="arrow" class="arrow" />
            </div>
            <div class="item flex-between" @click="handleShow(3)">
              <van-field
                readonly
                v-model="areaTxt"
                placeholder="选择所在区域"
              />
              <van-icon name="arrow" class="arrow" />
            </div>
          </div>
          <div class="mark">
            <h1>详细地址</h1>
            <div class="box">
              <van-field
                type="textarea"
                v-model="payInfo.detail"
                placeholder="请填写详细地址，50个字符内"
                maxlength="5  0"
              />
            </div>
          </div> -->
        </div>
      </div>
      <!-- 核算价格 -->
      <div class="price_total_wrap line flex-between">
        <div class="left">价格核算：</div>
        <div class="right">
          <span>¥ </span>
          <span v-if="formData.price">{{ formData.price | formatPrice }}</span>
          <span v-else>0.00</span>
        </div>
      </div>
      <!-- 实际价格 -->
      <div class="other_price_wrap">
        <div class="block">
          <h1>实际订单价格：</h1>
          <div class="input_box">
            <van-field
              v-model="priceReal"
              placeholder="请输入本次商品销售洽谈达成的实际价格"
              @input="handleBlurPrice"
              type="number"
            />
          </div>
        </div>
        <div class="block">
          <h1>差额核算：</h1>
          <p>
            <span>¥ </span>
            <span v-if="formData.diffrentprice">{{
              formData.diffrentprice | formatPrice
            }}</span>
            <span v-else>0.00</span>
          </p>
        </div>
        <div class="radio_wrap">
          <van-radio-group v-model="formData.paymsg">
            <van-radio name="银行转账" shape="square">银行转账</van-radio>
            <van-radio name="支付宝" shape="square">支付宝</van-radio>
            <van-radio name="微信支付" shape="square">微信支付</van-radio>
            <van-radio name="其他第三方支付" shape="square"
              >其他第三方支付</van-radio
            >
          </van-radio-group>
        </div>
        <div class="pay_from_wrap form_wrap">
          <div class="item">
            <van-field
              v-model="formData.paymsg_truename"
              placeholder="银行账户名 or 支付宝ID or 微信ID or 其他第三方支付名称"
            />
          </div>
          <div class="item">
            <van-field
              v-model="formData.paymsg_bank"
              placeholder="开户行信息（银行转账以外的支付类型，请勿填写此项）"
            />
          </div>
          <div class="item">
            <van-field
              v-model="formData.paymsg_account"
              placeholder="银行账号（银行转账以外的支付类型，请勿填写此项）"
            />
          </div>
          <div class="mark">
            <h1>备注信息：</h1>
            <div class="box">
              <van-field
                type="textarea"
                v-model="formData.saler_note"
                placeholder="如有需要，请填写备注说明，200个字符内"
                maxlength="200"
              />
            </div>
          </div>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="bottom-operation_wrap">
        <div class="custom_btn next" @click="handleNext">
          下一步 <span><i class="iconfont icon-selected"></i></span>
        </div>
        <!-- <div class="return" @click="handleReturn">←返回</div> -->
        <div class="primary-button return" @click="handleReturn">
          <i class="iconfont icon-yuyinjiantou"></i> 返回
        </div>
      </div>
    </div>
    <div class="confirm_wrap" v-else-if="step == 2">
      <div class="title line">销售代客下单（销售业务订单）</div>
      <div class="content line">
        <div class="block" v-for="(item, index) in selectIndexArr" :key="index">
          <h1>商品名称：{{ item.commodityname }}</h1>
          <div class="txt">
            <p v-for="(itemAttr, indexAttr) in item.attrItem" :key="indexAttr">
              {{ itemAttr }}
            </p>
          </div>
          <h1>
            商品数量：<span>{{ item.num }}</span>
          </h1>
          <h1>
            商品单价：￥<span>{{ item.price | formatPrice }}</span>
          </h1>
          <h1>
            商品总价：￥<span>{{ item.price_total | formatPrice }}</span>
          </h1>
        </div>
      </div>
      <div class="content line">
        <div class="address_wrap">
          <div class="item flex-rowl">
            <p>购买人：</p>
            <p>{{  customerDetail.info_truename
                    ? customerDetail.info_truename
                    : customerDetail.ext_name }}</p>
          </div>
          <div class="item flex-rowl">
            <p>企业名称：</p>
            <p>{{ customerDetail.other_companystr }}</p>
          </div>
          <div class="item flex-rowl">
            <p>联系方式：</p>
            <p>{{ customerDetail.info_mobile }}</p>
          </div>
          <div class="item flex-rowl">
            <p>所在地区：</p>
            <p>
              <span v-if="customerDetail.other_provincename">{{
                customerDetail.other_provincename
              }}</span>
              <span v-if="customerDetail.other_cityname"
                >、{{ customerDetail.other_cityname }}</span
              >
              <span v-if="customerDetail.other_areaname"
                >、{{ customerDetail.other_areaname }}</span
              >
              <span v-if="customerDetail.other_address"
                >、{{ customerDetail.other_address }}</span
              >
            </p>
          </div>
          <div class="item flex-rowl">
            <p>购买人联系方式：</p>
            <p>{{ customerDetail.info_mobile }}</p>
          </div>
          <div class="item flex-rowl">
            <p>收件人：</p>
            <p>{{ formData.truename }}</p>
          </div>
          <div class="item flex-rowl">
            <p>收件人联系方式：</p>
            <p>{{ formData.cellphone }}</p>
          </div>
          <div class="item flex-rowl">
            <p>所在地区：</p>
            <p>
              <span v-if="customerDetail.other_provincename">{{
                customerDetail.other_provincename
              }}</span>
              <span v-if="customerDetail.other_cityname"
                >、{{ customerDetail.other_cityname }}</span
              >
              <span v-if="customerDetail.other_areaname"
                >、{{ customerDetail.other_areaname }}</span
              >
              <span v-if="customerDetail.other_address"
                >、{{ customerDetail.other_address }}</span
              >
            </p>
          </div>
        </div>
      </div>
      <div class="content line">
        <div class="price flex-between">
          <p>价格核算：</p>
          <p>
            <span>¥ </span>
            <span v-if="formData.price">{{
              formData.price | formatPrice
            }}</span>
            <span v-else>0.00</span>
          </p>
        </div>
      </div>
      <div class="content line">
        <div class="price flex-between">
          <p>实际订单价格：</p>
          <p><span>￥</span>{{ priceReal }}</p>
        </div>
        <div class="price_btm flex-between">
          <p>差额：</p>
          <p>
            <span>¥ </span>
            <span v-if="formData.diffrentprice">{{
              formData.diffrentprice | formatPrice
            }}</span>
            <span v-else>0.00</span>
          </p>
        </div>
      </div>
      <div class="pay_wrap">
        <div class="tit">支付方式：{{ formData.paymsg }}</div>
        <div class="block">
          <p>银行账户名：{{ formData.paymsg_truename }}</p>
          <p>开户行：{{ formData.paymsg_bank }}</p>
          <p>银行账号：{{ formData.paymsg_account }}</p>
        </div>
        <div class="mark">
          <h1>备注信息：</h1>
          <p>{{ formData.saler_note }}</p>
        </div>
      </div>
      <!-- 底部操作 -->
      <div class="bottom-operation_wrap">
        <div class="custom_btn next" @click="handleSubmit">
          确认 <span><i class="iconfont icon-selected"></i></span>
        </div>
        <!-- <div class="return" @click="step = 1">←返回</div> -->
        <div class="primary-button return" @click="step = 1">
          <i class="iconfont icon-yuyinjiantou"></i> 返回
        </div>
      </div>
    </div>

    <!-- 商品列表弹窗  -->
    <van-overlay :show="isShowShop">
      <div class="popup-wrap">
        <div class="close" @click="isShowShop = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <div class="popup-main">
          <div class="search_wrap flex-between">
            <div class="input flex-rowl">
              <i class="iconfont icon-search"></i>
              <van-field
                v-model="shopForm.keyword"
                placeholder="查找商品 →"
                @keyup.enter="handleSearch"
              />
            </div>
            <div class="serch">查找显示</div>
          </div>
          <div class="scroll_wrap" style="height: 50vh">
            <div class="select_list">
              <div
                class="select_item flex-rowl"
                v-for="(item, index) in shopList"
                :key="index + 'a'"
                @click="handleSelectShop(item)"
              >
                <!-- <div
                  class="check flex-rowr"
                  :class="{ active: index === shopListCheck }"
                >
                  <i class="iconfont icon-gouxuan"></i>
                </div> -->
                <div class="main flex-rowl">
                  <div class="pic">
                    <van-image width="100%" height="100%" :src="item.img" />
                  </div>
                  <span>{{ item.commodityname }}</span>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="popup_bottom">
            <div class="custom_btn next">
              确认 <span><i class="iconfont icon-selected"></i></span>
            </div>
          </div> -->
        </div>
      </div>
    </van-overlay>
    <!-- 商品属性选择 -->
    <van-overlay :show="isShowShopAttr">
      <div class="popup-wrap custom_dialog_attr">
        <div class="close" @click="isShowShopAttr = false">
          <i class="iconfont icon-jujueweituo"></i>
        </div>
        <div class="popup-main" style="margin-top: 30px">
          <div class="scroll_wrap" style="height: 45vh">
            <div
              class="shop_attr_column"
              v-for="(item, index) in shopAttr"
              :key="index"
            >
              <div class="tit">{{ item.attrname }}</div>
              <div class="select_list flex-rowl">
                <div
                  v-for="(itemChild, indexChild) in item.items"
                  :key="indexChild"
                  @click="handleSelectAttr(item, itemChild, index)"
                  class="select_item flex-between"
                  :class="
                    selectIndexObj['select' + itemChild.attrid] ==
                    item.attrname + '-' + itemChild.attrvalue
                      ? 'active'
                      : ''
                  "
                >
                  <span class="txt">{{ itemChild.attrvalue }}</span>
                  <span
                    v-if="
                      selectIndexObj['select' + itemChild.attrid] ==
                      item.attrname + '-' + itemChild.attrvalue
                    "
                    class="iconfont icon-3tuihuanhuozhengcegouxuan"
                  ></span>
                </div>
              </div>
            </div>
          </div>
          <div class="popup_bottom">
            <div class="step_wrap flex-rowc">
              <van-stepper
                v-model="num"
                @change="handleChangeShopNum"
                :min="1"
              />
            </div>
            <div class="price_group">
              <div class="price_item flex-between">
                <p>商品标价核算：</p>
                <p class="price">
                  <span>¥</span> {{ selectIndexObj.price_total | formatPrice }}
                </p>
              </div>
            </div>
            <div class="custom_btn next" @click="handleQueryShopAttr">
              确认 <span><i class="iconfont icon-selected"></i></span>
            </div>
          </div>
        </div>
      </div>
    </van-overlay>

    <!-- 配送地址 -->
    <van-popup v-model="isAddress">
      <div class="addressPopup">
        <div class="body">
          <div class="address_list" v-if="addressList.length > 0">
            <div
              v-for="(item, index) in addressList"
              :key="index"
              @click="selectAddressId = item.id"
            >
              <div :key="index" class="address_item flex-rowl">
                <div class="radio">
                  <span
                    class="iconfont"
                    :class="
                      item.id == selectAddressId
                        ? 'icon-danxuanyixuan1'
                        : 'icon-quanxuan'
                    "
                  ></span>
                </div>
                <div class="address_content">
                  <p>姓名：{{ item.truename }}</p>
                  <p>手机号：{{ item.mobile }}</p>
                  <p>
                    物流类型：{{
                      item.runtype == 1
                        ? "私人"
                        : item.runtype == 2
                        ? "办公"
                        : ""
                    }}
                  </p>
                  <p>
                    所在地区：<span>{{ item.provincestr }}</span>
                    <span>{{ item.citystr }}</span>
                    <span>{{ item.areastr }}</span>
                    <span>{{ item.addr }}</span>
                  </p>
                </div>
              </div>
            </div>
          </div>
          <van-empty description="暂无数据" v-else />
        </div>
        <div class="footer flex-colc">
          <div class="btn" @click="handleQueryAddress">确认</div>
          <p @click="handleGo">前往添加物流信息→</p>
        </div>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getCommondity,
  getCommidityDetail,
  encryptstringview,
  getCustomerDetail,
  encryptstringadd,
} from "../../../api/api";
import {
  getShopHPfLogistics,
  getCustomAddressList,
} from "../../../api/company";
import { addXsOrder, getLogistics } from "../../../api/shop";
import { calculator } from "../../../utils/decimal";
import { mapState } from "vuex";
export default {
  name: "rServiceAddOrder",
  data() {
    return {
      id: "",
      loading: false,
      customerDetail: "",
      formData: {
        qyid: "",
        openid: "",
        ticket: "",
        goods: "",
        price_original: 0,
        price: 0,
        sendtime: "",
        addr: "",
        msg: "",
        ordertype: 43, // 2 = 普通商品订单 // 41=分销订单 42=团购订单 43=销售业务订单 44=批发订单 45=门店线下零售订单 46=门店线上应用零售订单 47=门店店仓提货  52=混批订单
        boxlogid: "",
        runfee: 0,
        score: 0,
        days: "",
        truename: "",
        cellphone: "",
        logisticsdf: 2, // 物流是否到付 =1=到付 2=其它
        diffrentprice: "", // 订单差额
        paymsg: "", // 支付信息
        paymsg_truename: "", // 支付信息-账户名
        paymsg_bank: "", // 支付信息-开户行
        paymsg_account: "", // 支付信息-账号
        saler: "", // 销售人员关联
        saler_note: "", // 销售人员备注
        qw_appid: "",
        qw_job: "",
        qy_truename: "",
        qy_linktype: "",
      },
      provinceList: [],
      provinceId: "",
      provinceText: "",
      cityList: [],
      cityId: "",
      cityText: "",
      areaList: [],
      areaId: "",
      areaText: "",
      addrText: "",

      actualMoney: "", // 实际价格
      payType: "", // 选择支付方式

      // 商品
      isShowShop: false,
      shopForm: {
        Page: 1,
        PageSize: 10,
        typeid: "",
        keyword: "",
        istop: "",
        comtype: "",
        scorewide: "",
        isintro: "", // 推荐 1 非推荐的 0， 留空则显示全部
        labels: "", // 可以输入特定标签，比如 爆款 新品
        ordertype: "", // 1 综合排序 2价格升序  3 价格降序 4积分升序  5积分降序
        brandid: "",
        commoditystate: 1, // 1 上架 0 下架 2 全部 留空为上架
        qyid: this.$store.state.USERINFO.qy
          ? this.$store.state.USERINFO.qy.id
          : 0,
      },
      isLoading: true,
      shopList: [],
      shopTotal: 0, // 商品总数量
      selectShop: {}, // 选中商品
      selectShopId: "", // 选中商品id
      shopDetail: {}, // 商品详情
      // 商品属性
      isShowShopAttr: false,
      shopAttr: [],
      selectIndexObj: {
        attrItem: [],
        arrItem: [],
        // priceReal: "",

        attr: [],
        // attr : v.commodityattr,
        commodityid: "",
        commoditylabel: "",
        // commoditylabel : v.commoditylabel,
        commodityname: "",
        num: 0,
        price: "", // 单价
        price_total: "", // 总价
        attrnumtype: "", // 属性价格变动类型： 不变、增加、减少
        attrnum: "", // 属性价格变动值
        codetype: "", // 优惠价类型 1-百分比、2-固定金额
        discount: "", // 优惠券值
      }, // 商品属性选中
      selectIndexArr: [], // 商品属性选中
      num: 1, // 数量
      priceReal: "", // 真实价格
      isSetAttr: false,
      setAttrIndex: "", // 设置属性的索引

      qyguid: "",
      logisticsMoney: 0, // 默认物流费用
      hpLogiMange: "", // 混批物流管理
      runfeeArr: [], // 多个商品的物流费用

      customerGuid: "", //
      isAddress: false, // 配送地址
      isLoadingAddress: false,
      addressList: [],
      selectAddressId: "",

      step: 1, // 步骤
      isType: 1,
      isShowPopup: false,
      

      // actualMoney: "", // 实际价格
      // payType: "", // 选择支付方式
      // shopKeyword: "",

      // initData: {
      //   province: "",
      //   city: "",
      //   area: "",
      //   detail: "",
      // },

      // payInfo: {
      //   accountId: "",
      //   name: "",
      //   account: "",
      //   mark: "",
      // },
      // step: 1,
      // isShow: false,

      // shopList: [
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      //   {
      //     src: "https://dev.vwingist.com/app_images/mall_smallapp/shop_suolue.png",
      //     txt: "Personalized series of women's clothing and accessories",
      //   },
      // ],
      // shopListCheck: "",

      // isType: 1,
      // provinceList: [],
      // provinceTxt: "",
      // cityList: [],
      // cityTxt: "",
      // areaList: [],
      // areaTxt: "",
      // loading: true,
      // isShowPopup: false,
    };
  },
  filters: {
    // 价格逗号分隔，保留两位小数
    formatPrice(price) {
      if (!price) return;
      const formattedPrice = Number(price)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return formattedPrice;
    },
  },
  computed: {
    ...mapState(["OPENID", "USERINFO"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    this.qyguid = USERINFO.qy.qyguid;
    this.getShopHPfLogistics();
    this.getLogistics();
    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id, customerGuid } = JSON.parse(res.jsondata);
        this.id = id;
        this.customerGuid = customerGuid;
        this.getCustomerDetail();
      } else {
        this.$router.back();
      }
    },
    // 获取默认物流
    getLogistics() {
      getLogistics({ qyguid: this.qyguid }).then((res) => {
        this.logisticsMoney = res.paydemo ? res.paydemo : 0;
        // this.formData.runfee = res.paydemo ? res.paydemo : 0;
      });
    },
    // 获取物流混批数据
    getShopHPfLogistics() {
      let params = {
        qyguid: this.qyguid,
        pageindex: 1,
        pagesize: 10,
      };
      getShopHPfLogistics(params).then((res) => {
        this.hpLogiMange = res.list.length > 0 ? res.list[0] : "";
      });
    },
    // 获取客户详情
    getCustomerDetail() {
      getCustomerDetail({ id: this.id }).then((res) => {
        this.customerDetail = res;
        this.formData.qw_appid = res.other_company;
        this.formData.qw_job = res.other_job;
        this.formData.qy_truename = res.info_truename;
        this.formData.qy_linktype = res.info_mobile;
      });
    },
    // 获取客户详情
    getCustomAddressList() {
      this.isLoadingAddress = true;
      getCustomAddressList({ guid: this.customerGuid }).then((res) => {
        let newRes = res.list.filter((v) => v.isuse == 1);
        this.addressList = newRes;
        this.isLoadingAddress = false;
      });
    },
    // 显示物流弹窗
    handleShowAddress() {
      this.isAddress = true;
      this.getCustomAddressList();
    },
    // 物流单选
    handleQueryAddress() {
      let { selectAddressId, addressList } = this;
      addressList.forEach((v) => {
        if (v.id == selectAddressId) {
          this.provinceText = v.provincestr;
          this.formData.truename = v.truename;
          this.formData.cellphone = v.mobile;
          this.formData.addr = v.provincestr + v.citystr + v.areastr + v.addr;
        }
      });
      this.editLogistics(this.hpLogiMange);
      this.isAddress = false;
    },

    // 搜索商品
    handleSearch() {
      this.shopForm.Page = 1;
      this.shopList = [];
      this.loadMore();
    },
    // 重置搜索结果
    handleRest() {
      this.shopForm.Page = 1;
      this.shopForm.keyword = "";
      this.shopList = [];
      this.loadMore();
    },
    async loadMore() {
      this.isLoading = true;
      try {
        const res = await getCommondity(this.shopForm);
        if (res.list.length > 0) {
          this.shopList = [...this.shopList, ...res.list];
          this.shopTotal = res.total;
          this.shopForm.Page += 1;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
    handleScroll() {
      const container = this.$refs.container;
      if (
        container.scrollTop + container.clientHeight >=
        container.scrollHeight
      ) {
        this.loadMore();
      }
    },

    // 商品详情
    getCommidityDetail(isAttr) {
      getCommidityDetail({ id: this.selectShopId }).then((res) => {
        if (isAttr) {
          this.shopDetail = res;
          this.shopAttr = res.attr;
        } else {
          this.shopDetail = res;
          this.shopAttr = res.attr;
          this.isShowShop = false;
          this.isShowShopAttr = true;
          this.defaultSelectAttr(res.attr, res);
        }
      });
    },

    // 添加商品
    handleAddShop() {
      this.selectShop = {};
      this.selectShopId = "";
      this.shopDetail = {};
      this.loadMore();
      for (let key in this.selectIndexObj) {
        if (key.startsWith("select")) {
          delete this.selectIndexObj[key];
        }
      }
      this.isShowShop = true;
    },
    // 移除商品
    handleRemoveShop(index) {
      this.selectIndexArr.splice(index, 1);
    },
    // 设置商品属性
    handleSetShopAttr(item, index) {
      this.shopAttr = [];
      this.isShowShopAttr = true;
      this.isSetAttr = true;
      this.selectIndexObj = item;
      this.num = item.num;
      this.setAttrIndex = index;
      this.selectShopId = item.commodityid;
      this.getCommidityDetail(true);
    },

    // 选中商品
    handleSelectShop(item) {
      // this.selectShop = item;
      this.selectShopId = item.id;
      this.getCommidityDetail();
    },
    // 确认商品
    // handleQueryShop() {
    //   if (!this.selectShop.id) {
    //     this.$toast("请选择商品！");
    //     return;
    //   }
    //   this.getCommidityDetail();
    // },

    // 操作商品的属性
    handleSelectAttr(item, itemChild, index) {
      this.selectIndexObj.arrItem[index] = itemChild;
      this.selectIndexObj.attrItem[index] =
        item.attrname + ":" + itemChild.attrvalue;
      this.selectIndexObj[`num`] = this.num;
      this.$set(
        this.selectIndexObj,
        `select${item.attrid}`,
        item.attrname + "-" + itemChild.attrvalue
      );
      this.getComputePrice(this.selectIndexObj, this.shopDetail);
    },
    // 默认选中属性
    defaultSelectAttr(arr, detail) {
      let arrItem = [];
      let attrItem = [];
      // arr.forEach((v) => {
      //   this.$set(
      //     this.selectIndexObj,
      //     `select${v.attrid}`,
      //     v.attrname + "-" + v.items[0].attrvalue
      //   );
      //   arrItem.push(v.items[0]);
      //   attrItem.push(v.attrname + ":" + v.items[0].attrvalue);
      // });
      this.selectIndexObj.commodityname = detail.commodityname;
      this.selectIndexObj.num = this.num;
      this.selectIndexObj.arrItem = arrItem;
      this.selectIndexObj.attrItem = attrItem;
      this.selectIndexObj.attr = attrItem;
      this.getComputePrice(this.selectIndexObj, detail);
    },
    // 计算价格
    getComputePrice(attrSelectObj, detail) {
      // 不同规格价格
      let attrPrice = 0;
      attrSelectObj.arrItem.forEach((v) => {
        // numtype-增加  numtype-减少
        if (v.numtype == "减少") {
          attrPrice = calculator(attrPrice).subtract(v.num).toNumber();
          // attrPrice += -(v.num)
        } else {
          attrPrice = calculator(attrPrice).add(v.num).toNumber();
          // attrPrice += v.num
        }
      });
      this.selectIndexObj.price_total = calculator(
        calculator(detail.price).add(attrPrice)
      )
        .multiply(this.num)
        .toNumber(); // 标价
      // if (attrSelectObj.priceReal == "") {
      //   this.selectIndexObj.priceDiff = "";
      //   return;
      // }
      // // this.selectIndexObj.priceReal = 0; // 实际价格
      // this.selectIndexObj.priceDiff = calculator(this.selectIndexObj.price_total)
      //   .subtract(this.selectIndexObj.priceReal)
      //   .toNumber(); // 差价
    },

    // 价格输入失去焦点
    handleBlurPrice() {
      let { price } = this.formData;
      if (price === 0) {
        this.$toast("请添加商品");
        this.priceReal = "";
        return;
      }
      // 移除非数字字符
      if (this.priceReal == "") {
        this.formData.diffrentprice = "";
        this.priceReal = "";
        return;
      }
      let newPrice = this.priceReal.replace(/[^\d.]/g, "");
      this.formData.diffrentprice = calculator(price)
        .subtract(Number(newPrice))
        .toNumber();
    },

    // 操作商品数量
    handleChangeShopNum(e) {
      if (e == undefined) {
        this.$nextTick(() => {
          this.num = 1;
        });
        this.selectIndexObj.num = this.num;
        this.getComputePrice(this.selectIndexObj, this.shopDetail);
        return;
      }
      let reg = /^[0-9]+$/;
      if (!reg.test(this.num)) {
        // this.$toast("当前只能输入整数")
        this.$nextTick(() => {
          this.num = parseInt(this.num);
        });
      }
      this.selectIndexObj.num = this.num;
      this.getComputePrice(this.selectIndexObj, this.shopDetail);
    },
    // 返回商品
    handleReturnShop() {
      let { isSetAttr } = this;
      if (!isSetAttr) {
        this.isShowShop = true;
        this.isShowShopAttr = false;
      } else {
        this.isShowShopAttr = false;
      }
    },
    handleQueryShopAttr() {
      let { isSetAttr, setAttrIndex, selectIndexObj, shopDetail, num } = this;
      let newSelectIndexObj = JSON.parse(JSON.stringify(selectIndexObj));
      let arrItemFilter = selectIndexObj.arrItem.filter(
        (element) => element !== undefined && element !== null
      );
      if (
        shopDetail.attr.length != 0 &&
        arrItemFilter.length != shopDetail.attr.length
      ) {
        this.$toast("请选择商品属性");
        return;
      }
      newSelectIndexObj.commodityname = shopDetail.commodityname;
      newSelectIndexObj.commodityid = shopDetail.id;
      newSelectIndexObj.price = shopDetail.price;
      newSelectIndexObj.num = num;
      // 商品属性的汇总 start
      let newAttrnum = 0;
      newSelectIndexObj.arrItem.forEach((v) => {
        if (v.numtype === "增加") {
          newAttrnum = calculator(newAttrnum).add(v.num).toNumber();
        } else if (v.numtype === "减少") {
          newAttrnum = calculator(newAttrnum).sub(v.num).toNumber();
        } else if (v.numtype === "不变") {
          newAttrnum = calculator(newAttrnum).add(v.num).toNumber();
        }
      });

      newSelectIndexObj.attrnumtype =
        newAttrnum < 0 ? "减少" : newAttrnum === 0 ? "不变" : "增加";
      newSelectIndexObj.attrnum =
        newAttrnum < 0 ? Math.abs(newAttrnum) : newAttrnum;
      console.log(selectIndexObj, newSelectIndexObj, "=====-------");
      // if (priceReal == "") {
      //   this.$toast("请输入商品实价！");
      //   return;
      // }
      if (!isSetAttr) {
        this.selectIndexArr.push(newSelectIndexObj);
      } else {
        this.selectIndexArr[setAttrIndex] = newSelectIndexObj;
        this.isSetAttr = false;
      }
      this.num = 1;
      this.isShowShopAttr = false;
      this.getComputePriceEnd();
      this.handleBlurPrice();
    },
    // 计算最终价格
    getComputePriceEnd() {
      let { selectIndexArr } = this;
      selectIndexArr.forEach((v) => {
        this.formData.price = calculator(this.formData.price)
          .add(v.price_total)
          .toNumber();
        this.formData.price_original = this.formData.price;
      });
    },

    // 根据地址判断是否修改物流费用
    editLogistics(shopLog) {
      let { provinceText, logisticsMoney } = this;
      // let that = this;
      let shopOrder = "";
      /**
       * 目前物流参数有两大类：商家物流管理、商品物流管理
       * 1、商家物流管理-混批
       * 2、商品物流管理
       *    2-1、零售物流runmsg-单个商品、购物车商品
       *    2-3、批发物流runmsg2-单个商品的批发（不同属性）
       * **/
      /**
       * 1、统一收费标准runtype=1；无特殊订单规则orderrule=1；无特殊地区规则specialarea=1
       * 2、统一收费标准runtype=1；特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；无特殊地区规则specialarea=1
       * 3、统一收费标准runtype=1；特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)，如果商品数量超出设定值则物流费用为0；特殊地区规则（物流费用增加）specialarea=2、specialprovincestr（地区名称，逗号分隔的字符串）
       * 4、免物流费用runtype=2；特殊订单规则设置、特殊地区规则设置将无效
       * 5、部分地区免物流费用runtype=3，provincestr（地区名称，逗号分隔的字符串）选中的成功物流费用为0；
       * 5-1、选中的城市，特殊订单规则设置、特殊地区规则设置将无效
       * 5-2、未选中的城市，无特殊订单规则orderrule=1；无特殊地区规则specialarea=1
       * 5-3、未选中的城市，特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；无特殊地区规则specialarea=1
       * 5-4、未选中的城市，特殊订单规则-商品数量免物流费orderrule=2、goodsfullnum(商品数量)；特殊地区规则（物流费用增加）specialarea=2、specialprovincestr（地区名称，逗号分隔的字符串）
       * **/
      // 商品的物流规则
      // let shopLog = ''
      // if (this.data.type == 1) {
      //   shopLog = shopOrder.shopItem[0].detail.runmsg ? shopOrder.shopItem[0].detail.runmsg : ''
      // } else if (this.data.type == 2 && shopOrder.shopItem[0].detail.runmsg2) {
      //   try {
      //     shopLog = JSON.parse(shopOrder.shopItem[0].detail.runmsg2);
      //   } catch (error) {
      //     shopLog = shopOrder.shopItem[0].detail.runmsg2
      //   }
      // }
      let newRunfeeArr = [];
      if (!shopLog || !shopLog.runtype) {
        newRunfeeArr.push(logisticsMoney);
        // that.runfeeArr = newRunfeeArr;
        return;
      }
      // 统一标准收取
      if (shopLog.runtype == 1) {
        if (shopLog.orderrule == 1 && shopLog.specialarea == 1) {
          newRunfeeArr.push(logisticsMoney);
          // that.runfeeArr = newRunfeeArr;
        }
        if (shopLog.orderrule == 1 && shopLog.specialarea == 2) {
          if (
            shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
          ) {
            // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
            let percent = calculator(shopLog.pernum).divide(100).toNumber();
            let newLogistics = calculator(logisticsMoney)
              .add(calculator(logisticsMoney).multiply(percent))
              .toNumber();
            newRunfeeArr.push(newLogistics);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
        if (shopLog.orderrule == 2 && shopLog.specialarea == 1) {
          if (shopLog.goodsfullnum <= shopOrder.checkLen) {
            newRunfeeArr.push(0);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
        if (shopLog.orderrule == 2 && shopLog.specialarea == 2) {
          if (shopLog.goodsfullnum <= shopOrder.checkLen) {
            newRunfeeArr.push(0);
            // that.runfeeArr = ;
            return;
          }
          if (
            shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
          ) {
            // 物流价 = 物流价-slogisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
            let percent = calculator(shopLog.pernum).divide(100).toNumber();
            let newLogistics = calculator(logisticsMoney)
              .add(calculator(logisticsMoney).multiply(percent))
              .toNumber();
            newRunfeeArr.push(newLogistics);
            // that.runfeeArr = ;
          } else {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
        }
      }
      // 免物流费用  --  到付
      if (shopLog.runtype == 2 || shopLog.runtype == 4) {
        newRunfeeArr.push(0);
        if (shopLog.runtype == 4) {
          this.formData.logisticsdf = 1;
        }
        // this.runfeeArr = newRunfeeArr;
      }
      // 部分地区免费物流
      if (shopLog.runtype == 3) {
        if (shopLog.provincestr.split(",").indexOf(provinceText) !== -1) {
          newRunfeeArr.push(0);
          // that.runfeeArr = ;
        } else {
          if (shopLog.orderrule == 1 && shopLog.specialarea == 1) {
            newRunfeeArr.push(logisticsMoney);
            // that.runfeeArr = ;
          }
          if (shopLog.orderrule == 1 && shopLog.specialarea == 2) {
            if (
              shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
            ) {
              // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
              let percent = calculator(shopLog.pernum).divide(100).toNumber();
              let newLogistics = calculator(logisticsMoney)
                .add(calculator(logisticsMoney).multiply(percent))
                .toNumber();
              newRunfeeArr.push(newLogistics);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
          if (shopLog.orderrule == 2 && shopLog.specialarea == 1) {
            if (shopLog.goodsfullnum <= shopOrder.checkLen) {
              newRunfeeArr.push(0);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
          if (shopLog.orderrule == 2 && shopLog.specialarea == 2) {
            if (shopLog.goodsfullnum <= shopOrder.checkLen) {
              newRunfeeArr.push(0);
              // that.runfeeArr = ;
              return;
            }
            if (
              shopLog.specialprovincestr.split(",").indexOf(provinceText) !== -1
            ) {
              // 物流价 = 物流价-logisticsMoney + 物流价-logisticsMoney * 增加费用的百分比-shopLog.pernum
              let percent = calculator(shopLog.pernum).divide(100).toNumber();
              let newLogistics = calculator(logisticsMoney)
                .add(calculator(logisticsMoney).multiply(percent))
                .toNumber();
              newRunfeeArr.push(newLogistics);
              // that.runfeeArr = ;
            } else {
              newRunfeeArr.push(logisticsMoney);
              // that.runfeeArr = ;
            }
          }
        }
      }
      this.runfeeArr = newRunfeeArr;
    },
    // 提交数据
    handleNext() {
      let { formData, selectIndexArr, priceReal, runfeeArr } =
        this;
      const maxRunfee = Math.max(...runfeeArr);
      this.formData.runfee = maxRunfee;
      console.log(formData, "==-==formData");
      if (formData.truename == "") {
        this.$toast("请输入收件人姓名！");
        return;
      }
      if (formData.cellphone == "") {
        this.$toast("请输入收件人联系方式！");
        return;
      }
      if (formData.addr == "") {
        this.$toast("请输入收件人配送地址！");
        return;
      }
      if (selectIndexArr.length == 0) {
        this.$toast("请选择商品！");
        return;
      }
      if (priceReal == "") {
        this.$toast("请填写实际订单价格！");
        return;
      }
      if (formData.paymsg == "") {
        this.$toast("请选择支付信息");
        return;
      }
      if (formData.paymsg_truename == "") {
        this.$toast("请输入支付信息-账户名");
        return;
      }
      if (formData.paymsg_bank == "") {
        this.$toast("请输入支付信息-开户行");
        return;
      }
      if (formData.paymsg_account == "") {
        this.$toast("请输入支付信息-账号");
        return;
      }
      this.step = 2
    },
    handleSubmit() {
      let { formData, selectIndexArr, USERINFO, OPENID, priceReal, runfeeArr } =
        this;
      const maxRunfee = Math.max(...runfeeArr);
      this.formData.runfee = maxRunfee;
      console.log(formData, "==-==formData");
      if (formData.truename == "") {
        this.$toast("请输入收件人姓名！");
        return;
      }
      if (formData.cellphone == "") {
        this.$toast("请输入收件人联系方式！");
        return;
      }
      if (formData.addr == "") {
        this.$toast("请输入收件人配送地址！");
        return;
      }
      if (selectIndexArr.length == 0) {
        this.$toast("请选择商品！");
        return;
      }
      if (priceReal == "") {
        this.$toast("请填写实际订单价格！");
        return;
      }
      if (formData.paymsg == "") {
        this.$toast("请选择支付信息");
        return;
      }
      if (formData.paymsg_truename == "") {
        this.$toast("请输入支付信息-账户名");
        return;
      }
      if (formData.paymsg_bank == "") {
        this.$toast("请输入支付信息-开户行");
        return;
      }
      if (formData.paymsg_account == "") {
        this.$toast("请输入支付信息-账号");
        return;
      }

      // this.formData.addr = provinceText + cityText + areaText + addrText;
      this.formData.openid = OPENID;
      this.formData.qyid = USERINFO.qy.id;
      this.formData.saler = USERINFO.truename;
      this.formData.price = priceReal;
      let newGoods = selectIndexArr.map(
        ({
          attr,
          commodityid,
          commoditylabel,
          commodityname,
          num,
          price,
          price_total,
          attrnumtype,
          attrnum,
          codetype,
          discount,
        }) => ({
          attr,
          commodityid,
          commoditylabel,
          commodityname,
          num,
          price,
          price_total,
          attrnumtype,
          attrnum,
          codetype,
          discount,
        })
      );
      this.formData.goods = JSON.stringify(newGoods);
      const Toast = this.$toast.loading({
        message: "提交中...",
        forbidClick: true,
      });
      addXsOrder(this.formData).then((res) => {
        if (res.result) {
          this.$toast.success(res.message);
          setTimeout(() => {
            this.$router.back();
          }, 2000);
        } else {
          Toast.clear();
          this.$toast.fail(res.message);
        }
      });
    },
    // 返回
    handleReturn() {
      this.$router.back();
    },

    handleGo() {
      this.encryptstringadd("addressList", {
        id: this.id,
        customerGuid: this.customerDetail.guid,
      });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 获取城市
    // getProvince(isClick) {
    //   getProvince().then((res) => {
    //     let newProvince = [];
    //     res.forEach((v) => {
    //       newProvince.push({
    //         text: v.areaname,
    //         id: v.areaid,
    //       });
    //     });
    //     this.provinceList = newProvince;
    //     this.loading = false;
    //     if (isClick) {
    //       this.isShowPopup = true;
    //     }
    //   });
    // },

    // 获取城市
    // getCity(isClick) {
    //   getCity(this.initData.province).then((res) => {
    //     let newcity = [];
    //     res.forEach((v) => {
    //       newcity.push({
    //         text: v.cityname,
    //         id: v.cityid,
    //       });
    //     });
    //     this.cityList = newcity;
    //     this.loading = false;
    //     if (isClick && newcity.length > 0) {
    //       this.isShowPopup = true;
    //     } else {
    //       this.$toast("暂无数据");
    //     }
    //   });
    // },
    // // 获取区域
    // getArea(isClick) {
    //   getArea(this.initData.city).then((res) => {
    //     let newarea = [];
    //     res.forEach((v) => {
    //       newarea.push({
    //         text: v.addrname,
    //         id: v.addrid,
    //       });
    //     });
    //     this.areaList = newarea;
    //     this.loading = false;
    //     if (isClick && newarea.length > 0) {
    //       this.isShowPopup = true;
    //     } else {
    //       this.$toast("暂无数据");
    //     }
    //   });
    // },

    // onConfirm(e) {
    //   let { isType } = this;
    //   if (isType == 1) {
    //     this.provinceTxt = e.text;
    //     this.initData.province = e.id;
    //     this.areaTxt = "";
    //     this.initData.area = "";
    //     this.cityTxt = "";
    //     this.initData.city = "";
    //     this.initData.addr = "";
    //   } else if (isType == 2) {
    //     this.cityTxt = e.text;
    //     this.initData.city = e.id;
    //     this.areaTxt = "";
    //     this.initData.area = "";
    //     this.initData.addr = "";
    //   } else if (isType == 3) {
    //     this.areaTxt = e.text;
    //     this.initData.area = e.id;
    //     this.initData.addr = "";
    //   }
    //   this.loading = true;
    //   this.isShowPopup = false;
    // },
    // // 显示弹窗
    // handleShow(type) {
    //   let { provinceTxt, cityTxt } = this;
    //   this.isType = type;
    //   if (type == 1) {
    //     this.getProvince(true);
    //   } else if (type == 2) {
    //     if (provinceTxt == "") {
    //       this.$toast("请选择省/直辖市");
    //       return;
    //     }
    //     this.getCity(true);
    //   } else if (type == 3) {
    //     if (provinceTxt == "") {
    //       this.$toast("请选择省/直辖市");
    //       return;
    //     }
    //     if (cityTxt == "") {
    //       this.$toast("请选择城市");
    //       return;
    //     }
    //     this.getArea(true);
    //   }
    // },

    // onClickHide() {
    //   this.isShow = false;
    // },
    // handleNext() {
    //   this.step = 2;
    // },
    // // 选择商品
    // handleSelect(index) {
    //   this.shopListCheck = index;
    // },
    // handleQuery() {
    //   this.onClickHide();
    // },
    // handleSubmit() {},
    // handleReturn() {
    //   this.$router.back();
    // },
  },
};
</script>
<style lang="less" scoped>
.orderPage {
  box-sizing: border-box;
  font-size: 24px;
  color: #3c3c3c;
  padding-bottom: 460px;
  .line {
    border-bottom: 9px solid #f5f5f5;
  }
  .title {
    padding: 48px 42px 33px;
  }

  .shop_intro_wrap {
    padding: 40px 57px 83px;
    font-size: 20px;
    .shop_list {
      border-bottom: 1px dashed #aaaaaa;
      margin-bottom: 44px;
    }

    h1 {
      font-size: 20px;
      margin-bottom: 9px;
    }
    p {
      font-size: 18px;
      color: #969696;
      margin-bottom: 15px;
      line-height: 30px;
    }
    .set_wrap {
      padding: 25px 0;
      font-size: 18px;
      color: #000000;
      border-bottom: 1px dashed #c3c3c3;
      text-align: left;
      p {
        padding: 0 15px;
        display: inline-block;
        height: 40px;
        line-height: 40px;
        border-radius: 30px;
        border: 1px solid #aaaaaa;
      }
    }
  }

  .receive_goods_info_wrap {
    padding: 60px 70px 90px;
    color: #333333;
  }

  .price_total_wrap {
    padding: 70px 57px;
    .right {
      font-size: 40px;
      span {
        font-size: 24px;
        margin-right: 20px;
      }
    }
  }
  .add_btn {
    width: 600px;
    height: 110px;
    font-size: 28px;
    color: #333333;
    border: 1px solid #aaaaaa;
    .iconfont {
      font-size: 38px;
      margin-right: 22px;
      color: #515151;
    }
  }

  .other_price_wrap {
    padding: 0 57px 50px;
    h1 {
      margin-bottom: 50px;
    }
    .input_wrap {
      .left {
        font-size: 30px;
        .iconfont {
          color: #c63520;
        }
      }
      .input_box {
        width: 560px;
        height: 60px;
        background: #f0f0f0;
        border: none;
        padding: 0 27px;
      }
    }
    .block {
      margin: 70px 0 80px;
      p {
        font-size: 30px;
      }
    }
    .radio_wrap {
      margin-bottom: 70px;
      /deep/ .van-radio {
        margin-bottom: 20px;
      }
    }
  }
  .bottom-operation_wrap {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    background: #ffffff;
    box-shadow: 0 0 10px 10px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    font-size: 24px;
    color: #000000;
    padding: 70px 125px 100px;
    .custom_btn {
      width: 500px;
      height: 60px;
      line-height: 60px;
      // background: #1e1e1e;
      border-radius: 0;
      margin: 0 auto 60px;
    }
    .return {
      font-size: 26px;
      // color: #333333;
      text-align: center;
    }
  }

  .form_wrap {
    width: 600px;
    margin: auto;
    .info_wrap {
      .info_item {
        margin-bottom: 18px;
        align-items: flex-start;
        &.address_item {
          margin-bottom: 60px;
          .txt {
            margin: 37px 0 25px;
            font-size: 24px;
          }
          p {
            font-size: 20px;
          }
          .address_box {
            margin-bottom: 20px;
          }
        }
        .label {
          width: 170px;
          flex-shrink: 0;
        }
        p {
          line-height: 30px;
        }
      }
    }
    .list_mb {
      margin-bottom: 120px;
    }
    .list_mb1 {
      margin-bottom: 70px;
    }
    .tit {
      margin-bottom: 40px;
      .icon-address-outlined {
        font-size: 30px;
        color: #515151;
        margin-left: -10px;
      }
      .icon-bitian {
        color: #c63520;
      }
    }
    .item {
      border-bottom: 1px dashed #c3c3c3;
      height: 73px;
      padding: 0 10px;
      margin-bottom: 32px;
    }
    /deep/ .van-cell {
      padding: 0;
      height: 100%;
    }
    /deep/ .van-field__body {
      font-size: 12px;
      height: 100%;
    }
    .mark {
      h1 {
        margin-bottom: 20px;
        font-size: 24px;
      }
      .box {
        width: 600px;
        height: 190px;
        background: #fafafa;
        padding: 19px 22px;
        box-sizing: border-box;
        /deep/ .van-cell {
          background: transparent;
        }
        /deep/ .van-field__control {
          height: 100%;
        }
      }
    }
  }

  .confirm_wrap {
    .content {
      padding: 39px 42px 47px;
      .block {
        margin-bottom: 50px;
        &:last-child {
          margin-bottom: 0;
        }
        h1 {
          font-size: 20px;
          color: #3c3c3c;
          margin-bottom: 9px;
        }
        .txt {
          margin-bottom: 19px;
          p {
            font-size: 18px;
            color: #969696;
            line-height: 30px;
            margin-bottom: 10px;
            &:last-child {
              margin-bottom: 0;
            }
          }
        }
      }
      .price {
        font-size: 24px;
        p {
          &:last-child {
            font-size: 40px;
            span {
              font-size: 24px;
              margin-right: 10px;
            }
          }
        }
      }
      .price_btm {
        margin-top: 50px;
        font-size: 24px;
        p {
          &:last-child {
            font-size: 20px;
            span {
              font-size: 22px;
            }
          }
        }
      }
    }
    .address_wrap {
      font-size: 22px;
      .item {
        margin-bottom: 30px;
        p {
          &:first-child {
            width: 190px;
          }
        }
      }
      .txt {
        font-size: 20px;
        line-height: 30px;
      }
    }
    .pay_wrap {
      padding: 42px 57px 0;
      font-size: 24px;
      box-sizing: border-box;
      .tit {
        margin-bottom: 70px;
      }
      .block {
        font-size: 22px;
        color: #aaaaaa;
        margin-bottom: 59px;
        padding-left: 39px;
        p {
          margin-bottom: 35px;
          &:last-child {
            margin-bottom: 0;
          }
        }
      }
      .mark {
        font-size: 22px;
        padding-left: 39px;
        p {
          color: #aaaaaa;
          margin-top: 28px;
        }
      }
    }
  }

  .popup-wrap {
    height: 70vh;
    width: 100%;
    background: #fff;
    position: absolute;
    bottom: 0;
    .close {
      position: absolute;
      left: 50%;
      top: -90px;
      color: #fff;
      .icon-jujueweituo {
        font-size: 50px;
      }
    }
    .popup-main {
      padding-top: 20px;
      /deep/ .van-cell {
        padding: 0;
        font-size: 12px;
        background: none;
        height: 100%;
      }
      .search_wrap {
        width: 660px;
        border-bottom: 1px solid #dddddd;
        padding: 29px 15px 20px;
        margin: 0 auto 50px;
        .iconfont {
          margin-right: 20px;
          font-size: 32px;
        }
        .serch {
          width: 130px;
          height: 40px;
          line-height: 40px;
          background: #1e1e1e;
          font-size: 18px;
          color: #fff;
          text-align: center;
        }
      }
      .scroll_wrap {
        padding-bottom: 40px;
        box-sizing: border-box;
        overflow-y: scroll;

        .select_list {
          width: 660px;
          margin: auto;
          .select_item {
            margin-bottom: 30px;
            .check {
              color: #dadada;
              &.active {
                color: #333333;
              }
              .iconfont {
                font-size: 34px;
              }
            }
            .main {
              margin-left: 15px;
              align-items: flex-start;
              .pic {
                width: 130px;
                height: 130px;
                flex-shrink: 0;
                margin-right: 20px;
              }
            }
          }
        }
        .shop_attr_column {
          margin-bottom: 30px;
          .tit {
            width: 660px;
            font-size: 26px;
            color: #3c3c3c;
            position: relative;
            margin: 0 auto 30px;
            &::before {
              position: absolute;
              width: 4px;
              height: 25px;
              top: 50%;
              transform: translateY(-50%);
              background: #ff0042;
              display: inline-block;
              content: "";
              left: -15px;
            }
          }
          .select_list {
            flex-wrap: wrap;
            .select_item {
              padding: 0 15px 0 17px;
              background: #f5f5f5;
              border-radius: 15px;
              font-size: 22px;
              color: #3c3c3c;
              margin: 0 20px 20px 0;
              position: relative;
              min-width: 125px;
              border: 3px solid #f5f5f5;
              box-sizing: border-box;
              cursor: pointer;
              height: 50px;
              &.active {
                background: #fff;
                border: 2px solid #f5f5f5;
                box-sizing: border-box;
              }
              .icon-3tuihuanhuozhengcegouxuan {
                font-size: 32px;
                color: #ff0042;
              }
            }
          }
        }
      }
      .popup_bottom {
        height: 270px;
        border-bottom: 1px dashed #3c3c3c;
        box-shadow: 0 -1px 8px 2px rgba(0, 0, 0, 0.05);
        position: absolute;
        left: 0;
        bottom: 0;
        right: 0;
        background: #fff;
        .custom_btn {
          margin: 85px auto 0;
        }
      }
    }
    &.custom_dialog_attr {
      .popup_bottom {
        height: 300px;
        padding-top: 30px;
        box-sizing: border-box;
        .price_group {
          padding: 30px 30px 0;
          font-size: 26px;
        }
        .custom_btn {
          margin-top: 40px;
        }
      }
    }
  }
  .addressPopup {
    width: 680px;
    height: 55vh;
    box-sizing: border-box;
    padding: 40px 30px;
    position: relative;
    .body {
      height: 42vh;
      overflow-y: scroll;
      .address_item {
        font-size: 24px;
        border: 2px solid #dcdcdc;
        color: #6e6e6e;
        padding: 20px 15px;
        margin-bottom: 20px;
        cursor: pointer;
        .radio {
          margin-right: 14px;
          .iconfont {
            font-size: 32px;
            color: #a5a5a5;
            &.icon-danxuanyixuan1 {
              color: #f62560;
            }
          }
        }
        p {
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .footer {
      height: 10vh;
      font-size: 22px;
      color: #fe3c46;
      position: fixed;
      left: 0;
      bottom: 0;
      right: 0;
      .btn {
        width: 280px;
        height: 55px;
        border-radius: 25px;
        text-align: center;
        line-height: 50px;
        font-size: 22px;
        color: #fff;
        background: #f62560;
        margin-bottom: 30px;
      }
    }
  }
  .primary-button {
    height: 70px;
    line-height: 70px;
    color: #fff;
  }
}
</style>